import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";

const app = createApp(App)
//清除公共样式
import "./assets/css/reset.css"
//引入element-plus组件库
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
// import locale from 'element-plus/lib/locale/lang/zh-cn'
app.use(router).use(ElementPlus).mount("#app");
